import { render, staticRenderFns } from "./Page-Jumbotron.vue?vue&type=template&id=7bcccb41&"
import script from "./Page-Jumbotron.vue?vue&type=script&lang=js&"
export * from "./Page-Jumbotron.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports